/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd. <legal@vecros.com>
 * Proprietary and confidential.
 **********************************************************************************/

/**
 * AI Assistant design tokens.
 *
 * The assistant needs a real accent; it is defined here and mapped to the app's
 * accent blue (#006BCE, used app-wide) so the assistant matches the rest of the UI.
 */

export const AI_ACCENT = "#006BCE";
export const AI_ACCENT_DARK = "#4C9AFF"; // accessible on black grounds

// Reserved for AI-only moments (mascot, launcher glow, streaming shimmer).
export const AI_GRADIENT = "linear-gradient(135deg, #006BCE, #7C5CFC)";

// Semantic accents used by the assistant.
export const STEP_SUCCESS = "#2C9B67";
export const STEP_SUCCESS_SOFT = "rgba(44,155,103,0.12)";

/** Resolve the accent for the current MUI theme mode. */
export const accentFor = (theme) =>
  theme?.palette?.mode === "dark" ? AI_ACCENT_DARK : AI_ACCENT;

/** Fixed shape constants. */
export const SHAPE = {
  drawerWidth: 420,
  panelRadius: 12,
  bubbleRadius: "16px 16px 16px 4px",
  bubbleRadiusUser: "16px 16px 4px 16px",
  cardRadius: 11,
  drawerShadow: "0 8px 32px rgba(0,0,0,0.15)",
  cardShadow: "0 2px 8px rgba(0,0,0,0.10)",
};
